module.exports = __webpack_public_path__ + "img/ab-page1-img1.87c202c0.png";